import { NgModule } from '@angular/core';
import { LoginComponent } from './login.component';
import { VerifyPhoneComponent } from './verify-phone.component';
import { RegisterComponent } from './register.component';
import { LogoutComponent } from './logout.component';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CustomFormsModule } from 'ng2-validation'
import { FlashMessagesModule } from 'angular2-flash-messages';
import { ForgotPasswordComponent } from './forgot-password.component';
import { SelectModule } from 'ng-select';
import { LoginBusinessComponent } from './business/login-business.component';
import { LinkAccountComponent } from './link-account.component';
import { RegisterIcheckComponent } from './register-icheck/register-icheck.component';
import { ResetPasswordLoginComponent } from './reset-password-login.component'
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    SelectModule,
    CommonModule,
    FormsModule,
    RouterModule,
    CustomFormsModule,
    FlashMessagesModule,
    TranslateModule,
  ],
  declarations: [
    LoginComponent,
    RegisterComponent,
    LogoutComponent,
    VerifyPhoneComponent,
    ForgotPasswordComponent,
    LoginBusinessComponent,
    LinkAccountComponent,
    RegisterIcheckComponent,
    ResetPasswordLoginComponent
  ],
  exports: [
    LoginComponent,
    RegisterComponent,
    LogoutComponent,
    VerifyPhoneComponent,
    LoginBusinessComponent,
    LinkAccountComponent,
    RegisterIcheckComponent,
    ResetPasswordLoginComponent
  ],
})
export class AuthenticateModule {
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/auth/authenticate.module.ts